import { AnimatePresence, motion } from 'motion/react';

import { ChatPanelState, useChatPanelState } from '@/pages/RobinJrChat/lib';
import { RobinJrBackground } from '../../../assets';
import { useStyles } from './PageBackground.styles';

export const PageBackground = () => {
  const classes = useStyles();
  const chatPanelState = useChatPanelState();

  return (
    <AnimatePresence>
      {chatPanelState !== ChatPanelState.Closed && (
        <motion.div
          key="background-open"
          css={[classes.background, classes.backgroundOpen]}
          initial={{ scale: 0, translateX: '-50%' }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          transition={{ duration: 0.22 }}>
          <RobinJrBackground />
        </motion.div>
      )}
      {chatPanelState === ChatPanelState.Closed && (
        <motion.div
          key="background-closed"
          css={[classes.background, classes.backgroundClosed]}
          initial={{ scale: 0, translateX: '-50%' }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          transition={{ duration: 0.22 }}>
          <RobinJrBackground />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
